import React, { PureComponent } from "react";
import TeamReportsTopNavigation from "../components/team-reports/navigation/top";
import TeamReportsSection1 from "../components/team-reports/sections/section-1";
import TeamReportsSection2 from "../components/team-reports/sections/section-2";
import TeamReportsSection3 from "../components/team-reports/sections/section-3";
import TeamReportsSection4 from "../components/team-reports/sections/section-4";
import TeamReportsSection5 from "../components/team-reports/sections/section-5";
import TeamReportsSection6 from "../components/team-reports/sections/section-6";
import TeamReportsSection7 from "../components/team-reports/sections/section-7";
import Teams, { persistTeamColorIndexMap } from "../api/Teams";
import { getRequest } from "../api/ApiService";
import { fetchCompetitionMetrics, fetchCompetitiveAnalysis } from "../api/MetricsService";
import { fetchTeamDecisions } from "../api/TeamDecisionsService";
import { fetchAllStaticData } from "../api/StaticDataService";
import { fetchFinancialStatements } from "../api/FinancialStatementsService";
import EventEmitter from "../services/event-emitter";
import { Loader } from "react-loaders";

class TeamReports extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      loading6: true,
      loading7: true,
      loading8: true,
      loading9: true,
      loading10: true,
      loading11: true,
      section: 1,
      step: 1,
      data: {},
      teams: {},
      expected: {},
      actual: {},
      competition_metrics: {},
      netRevenues: 0,
      netProfits: 0,
      costOfSales: 0,
      rndCosts: 0,
      promotionCosts: 0,
      sellingCosts: 0,
      holdingCosts: 0,
      avgMaterialCostsPerUnit: 0,
      avgLaborCostsPerUnit: 0,
      avgOverheadCostsPerUnit: 0,
      interestExpense: 0,
      financeRaised: 0,
      returnedToInvestors: 0,
      currentRound: props.currentRound,
      roundInUrl: props.roundInUrl,
      rounds: props.rounds,
      endingInventory: 0,
      totalCosts: 0,
      team_grade: 0,
      rank_name: "",
      metrics: {
        debt: "0.00",
        equity: "100.00",
        wacc: "0.00"
      },
      incomeStatement: {
        costOfSales: {
          name: "Cost of Sales",
          data: {}
        },
        revenues: {
          name: "Net Revenues",
          data: {}
        },
        grossProfits: {
          name: "Gross Profit",
          data: {}
        },
        RnDCosts: {
          name: "R&D Costs",
          data: {}
        },
        holdingCosts: {
          name: "Holding Costs",
          data: {}
        },
        promotionCosts: {
          name: "Promotion Costs",
          data: {}
        },
        sellingCosts: {
          name: "Selling Costs",
          data: {}
        },
        gnACosts: {
          name: "Other G&A Costs",
          data: {}
        },
        incomingBeforeTaxes: {
          name: "Income Before Taxes",
          data: {}
        },
        taxes: {
          name: "Taxes",
          data: {}
        },
        totalOperatingExpenses: {
          name: "Total Operating Costs",
          data: {}
        },
        totalNonOperatingCost: {
          name: "Total Non-Operating Costs",
          data: {}
        },
        gainOrLossoFSales: {
          name: "Gain or Loss of Sales",
          data: {}
        },
        interestExpense: {
          name: "Interest Expense",
          data: {}
        },
        otherNonOperatingCosts: {
          name: "Other Non-Operating Costs",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        }
      },
      balanceSheet: {
        accountsPayable: {
          name: "Accounts Payable",
          data: {}
        },
        accountsReceivable: {
          name: "Accounts Receivable",
          data: {}
        },
        accruedExpenses: {
          name: "Accrued Expenses",
          data: {}
        },
        accumulatedDepreciation: {
          name: "Accumulated Depreciation",
          data: {}
        },
        additionalPaidinCapital: {
          name: "Additional Paid in Capital",
          data: {}
        },
        begRetainedEarnings: {
          name: "Beg Retained Earnings",
          data: {}
        },
        cash: {
          name: "Cash",
          data: {}
        },
        commonStock: {
          name: "Common Stock",
          data: {}
        },
        currentLiabilities: {
          name: "Current Liabilities:",
          data: {}
        },
        deferredRevenues: {
          name: "Deferred Revenues",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        inventory: {
          name: "Inventory",
          data: {}
        },
        longTermDebt: {
          name: "Long Term Debt",
          data: {}
        },
        longTermLiabilities: {
          name: "Long Term Liabilities:",
          data: {}
        },
        netIncome: {
          name: "Net Income",
          data: {}
        },
        otherCurrentLiabilities: {
          name: "Other Current Liabilities",
          data: {}
        },
        otherLongTermLiabilities: {
          name: "Other Long Term Liabilities",
          data: {}
        },
        ppe: {
          name: "PPE",
          data: {}
        },
        preferredStock: {
          name: "Preferred Stock",
          data: {}
        },
        prepaidExpenses: {
          name: "Prepaid Expenses",
          data: {}
        },
        shortTermDebt: {
          name: "Short Term Debt",
          data: {}
        },
        supplies: {
          name: "Supplies",
          data: {}
        },
        totalAssets: {
          name: "Total Assets",
          data: {}
        },
        totalCurrentAssets: {
          name: "Total Current Assets",
          data: {}
        },
        totalCurrentLiabilities: {
          name: "Total Current Liabilities",
          data: {}
        },
        totalEquity: {
          name: "Total Equity",
          data: {}
        },
        totalLiabilities: {
          name: "Total Liabilities",
          data: {}
        },
        totalLongTermAssets: {
          name: "Total Long Term Assets",
          data: {}
        },
        totalLongTermLiabilities: {
          name: "Total Long Term Liabilities",
          data: {}
        }
      },
      cashFlow: {
        beginningCash: {
          name: "Beginning Cash",
          data: {}
        },
        capitalExpenditurePurchases: {
          name: "Capital Expenditure Purchases",
          data: {}
        },
        capitalExpenditureSales: {
          name: "Capital Expenditure Sales",
          data: {}
        },
        cashpaymentforIncomeTaxes: {
          name: "Cash payment for Income Taxes",
          data: {}
        },
        cashpaymentforInterests: {
          name: "Cash payment for Interests",
          data: {}
        },
        cashpaymentsforOperatingexpenses: {
          name: "Cash payments for Operating expenses",
          data: {}
        },
        cashpaymentsforPurchases: {
          name: "Cash payments for Purchases",
          data: {}
        },
        cashpaymentsforWages: {
          name: "Cash payment for Wages",
          data: {}
        },
        cashreceivedfromCustomers: {
          name: "Cash received from Customers",
          data: {}
        },
        debtBorrowed: {
          name: "Debt Borrowed",
          data: {}
        },
        debtRepaid: {
          name: "Debt Repaid",
          data: {}
        },
        dividends: {
          name: "Dividends",
          data: {}
        },
        endingCash: {
          name: "Ending Cash",
          data: {}
        },
        investmentPurchases: {
          name: "Investment Purchases",
          data: {}
        },
        investmentSales: {
          name: "Investment Sales",
          data: {}
        },
        netChangeinCash: {
          name: "Net Change in Cash",
          data: {}
        },
        stockIssuance: {
          name: "Stock Issuance",
          data: {}
        },
        stockRepurchase: {
          name: "Stock Repurchase",
          data: {}
        },
        totalCashFlowsfromFinancing: {
          name: "Total Cash Flows from Financing",
          data: {}
        },
        totalCashFlowsfromInvesting: {
          name: "Total Cash Flows from Investing",
          data: {}
        },
        totalCashFlowsfromOperations: {
          name: "Total Cash Flows from Operations",
          data: {}
        }
      },
      total_demand: {
        auto: 0,
        mobile: 0,
        total: 0
      },
      share_price: 0
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    this.fetchData();
    this.eventemitter.on("team-reports-go-to-section", this.goToSection);
  }

  componentWillUnmount() {
    this.eventemitter.off("team-reports-go-to-section", this.goToSection);
  }

  getCompetitiveAnalysisRoundId() {
    const { currentRound, roundInUrl, rounds } = this.state;

    let roundId = null;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      let round = rounds.find(i => i.number === roundInUrl);
      if (round) {
        roundId = round.id;
      }
    } else {
      let round = rounds.find(i => i.number === currentRound);
      if (round) {
        if (round.is_finished === true) {
          roundId = round.id;
        } else {
          const round_number = currentRound - 1;
          if (round_number > 0) {
            round = rounds.find(i => i.number === round_number);
            if (round) {
              roundId = round.id;
            }
          }
        }
      }
    }

    return roundId;
  }

  componentWillReceiveProps(nextProps) {
    let needUpdate = false;
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      needUpdate = true;
    }

    if (this.state.currentRound !== nextProps.currentRound) {
      needUpdate = true;
    }

    if (this.state.rounds.length === 0 && nextProps.rounds.length !== 0) {
      needUpdate = true;
    }

    const round1 = this.state.rounds.find(
      i => i.number === nextProps.currentRound
    );
    const round2 = nextProps.rounds.find(
      i => i.number === nextProps.currentRound
    );
    if (round1 && round2 && round1.is_finished !== round2.is_finished) {
      needUpdate = true;
    }

    if (needUpdate === true) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl,
          currentRound: nextProps.currentRound,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
        }
      );
    }
  }

  fetchData = () => {
    let teams = {};
    let data = {};

    this.setState({
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      loading6: true,
      loading7: true,
      loading8: true,
      loading9: true,
      loading10: true,
      loading11: true
    });

    this.loadFinancialStatements();
    this.loadStaticData();

    // Use team-decisions data from Analysis.js props if available,
    // otherwise fetch our own
    if (this.props.manufactureCosts || this.props.inventoryBalances) {
      this.processTeamDecisionsFromProps();
    } else {
      this.loadTeamDecisionsData();
    }

    this.loadMetricsAndCompetition();
    this.loadTeamGrade();

    Teams.teams().forEach(item => {
      teams[item.id] = item.name;
      data[item.id] = {};
    });

    this.setState(
      {
        teams,
        data
      },
      () => {
        this.loadState();
      }
    );
  };

  loadState = () => {
    if (this.joinRequest) {
      this.joinRequest.abort();
      this.joinRequest = null;
    }

    const roundId = this.getCompetitiveAnalysisRoundId();
    if (roundId) {
      const currentTeam = Teams.teams()[0];
      const competitionId = currentTeam ? Number(currentTeam.competition) : 0;

      fetchCompetitiveAnalysis(competitionId, roundId)
        .then(caData => {
          let data = { ...this.state.data };
          const exclude_keys = [
            "created_at",
            "id",
            "is_actual",
            "reason",
            "round",
            "team",
            "updated_at"
          ];

          caData.forEach(item => {
            if (item.team in data) {
              Object.keys(item).forEach(key => {
                if (exclude_keys.includes(key)) {
                  return;
                }

                data[item.team][key] = item[key] === null ? 0 : item[key];
              });
            }
          });

          this.setState({
            data,
            loading2: false
          });
        })
        .catch(err => { });
    }
  };

  loadFinancialStatements = () => {
    let incomeStatement = { ...this.state.incomeStatement };
    let balanceSheet = { ...this.state.balanceSheet };
    let cashFlow = { ...this.state.cashFlow };

    for (let key in incomeStatement) {
      incomeStatement[key].data = { value: 0 };
    }
    for (let key in balanceSheet) {
      balanceSheet[key].data = { value: 0 };
    }
    for (let key in cashFlow) {
      cashFlow[key].data = { value: 0 };
    }

    const roundLte = this.state.roundInUrl !== null && this.state.roundInUrl !== this.props.currentRound
      ? this.state.roundInUrl
      : this.props.currentRound;

    fetchFinancialStatements({ roundLte })
      .then(data => {
        const { rounds } = this.props;
        const current_year = this.current_year;

        let netRevenues = 0;
        let netProfits = 0;
        let costOfSales = 0;
        let rndCosts = 0;
        let promotionCosts = 0;
        let sellingCosts = 0;
        let holdingCosts = 0;
        let interestExpense = 0;

        // Process income statement
        for (let key in incomeStatement) {
          // eslint-disable-next-line
          data.incomeStatement.forEach(item => {
            let round_id = item.round;
            let round = rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = incomeStatement[key].name;

            if (round_number === current_year && item[hash]) {
              incomeStatement[key].data.value = item[hash];

              if (hash === "Net Revenues") {
                netRevenues = item[hash];
              } else if (hash === "Net Income") {
                netProfits = item[hash];
              } else if (hash === "Cost of Sales") {
                costOfSales = item[hash];
              } else if (hash === "R&D Costs") {
                rndCosts = item[hash];
              } else if (hash === "Promotion Costs") {
                promotionCosts = item[hash];
              } else if (hash === "Selling Costs") {
                sellingCosts = item[hash];
              } else if (hash === "Holding Costs") {
                holdingCosts = item[hash];
              } else if (hash === "Interest Expense") {
                interestExpense = item[hash];
              }
            }
          });
        }

        // Process balance sheet
        for (let key in balanceSheet) {
          data.balanceSheet.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;

            if (round_number === current_year) {
              const hash = balanceSheet[key].name;
              if (item[hash]) {
                balanceSheet[key].data.value = item[hash];
              }
            }
          });
        }

        // Process cashflow
        let debtBorrowed = 0;
        let stockIssuance = 0;
        let debtRepaid = 0;
        let dividends = 0;
        let stockRepurchase = 0;

        for (let key in cashFlow) {
          // eslint-disable-next-line
          data.cashflow.forEach(item => {
            let round_id = item.round;
            let round = this.props.rounds.find(i => i.id === round_id);
            let round_number = round.number;
            const hash = cashFlow[key].name;

            if (round_number === current_year && item[hash]) {
              cashFlow[key].data.value = item[hash];

              if (hash === "Stock Repurchase") {
                stockRepurchase = item[hash];
              } else if (hash === "Dividends") {
                dividends = item[hash];
              } else if (hash === "Debt Repaid") {
                debtRepaid = item[hash];
              } else if (hash === "Stock Issuance") {
                stockIssuance = item[hash];
              } else if (hash === "Debt Borrowed") {
                debtBorrowed = item[hash];
              }
            }
          });
        }

        const financeRaised = debtBorrowed + stockIssuance;
        const returnedToInvestors = debtRepaid + dividends + stockRepurchase;

        // Process financial analysis
        let actual = {};
        let expected = {};

        data.financialAnalysis.forEach(item => {
          if (item.is_actual === true) {
            actual[item.target_round_number] = item;
          } else {
            expected[item.target_round_number] = item;
          }
        });

        this.setState({
          netRevenues,
          netProfits,
          costOfSales,
          rndCosts,
          promotionCosts,
          sellingCosts,
          holdingCosts,
          interestExpense,
          incomeStatement,
          balanceSheet,
          cashFlow,
          financeRaised,
          returnedToInvestors,
          actual,
          expected,
          loading1: false,
          loading3: false,
          loading8: false,
          loading9: false
        });
      })
      .catch(err => { });
  };

  goToSection = section => {
    this.changeStep(section, 1);
  };

  changeStep = (section, step) => {
    this.setState(
      {
        section,
        step
      },
      () => {
        this.eventemitter.trigger("team-reports-change-section", [
          this.state.section
        ]);
      }
    );
  };

  getActualYearParam(year, key) {
    if (year in this.state.actual) {
      let obj = this.state.actual[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  getExpectedYearParam(year, key) {
    if (year in this.state.expected) {
      let obj = this.state.expected[year];
      if (key in obj) {
        return obj[key];
      }
    }

    return 0;
  }

  get expectedNetProfits() {
    return this.getExpectedYearParam(this.current_year, "net_income");
  }

  get actualNetProfits() {
    return this.getActualYearParam(this.current_year, "net_income");
  }

  get current_year() {
    const { currentRound, roundInUrl } = this.state;

    let current_year = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_year = roundInUrl;
    }

    return current_year;
  }

  loadStaticData = () => {
    const round_number = this.current_year;

    fetchAllStaticData(round_number)
      .then(data => {
        let total_demand = {
          auto: 0,
          mobile: 0,
          total: 0
        };
        const obj = data.totalDemand.find(i => i.round_number === round_number);

        if (obj) {
          total_demand.auto = obj.auto;
          total_demand.mobile = obj.mobile;
          total_demand.total = obj.total;
        }

        const constants = data.constants;
        const share_price = constants ? constants.initial_share_price : 0;

        this.setState({
          total_demand,
          share_price,
          loading4: false,
          loading10: false
        });
      })
      .catch(err => { });
  };

  processTeamDecisionsFromProps = () => {
    let totalCosts = 0;
    let avgMaterialCostsPerUnit = 0;
    let avgLaborCostsPerUnit = 0;
    let avgOverheadCostsPerUnit = 0;
    let endingInventory = 0;

    if (this.props.manufactureCosts) {
      this.props.manufactureCosts.forEach(product => {
        totalCosts += product.total_costs || 0;
        avgMaterialCostsPerUnit += product.material_costs || 0;
        avgLaborCostsPerUnit += product.labor_costs || 0;
        avgOverheadCostsPerUnit += product.overhead_costs || 0;
      });
    }

    if (this.props.inventoryBalances) {
      this.props.inventoryBalances.forEach(product => {
        endingInventory += product.ending_inventory || 0;
      });
    }

    this.setState({
      totalCosts,
      avgMaterialCostsPerUnit,
      avgLaborCostsPerUnit,
      avgOverheadCostsPerUnit,
      endingInventory,
      loading5: false,
      loading6: false
    });
  };

  loadTeamDecisionsData = () => {
    const round_number = this.current_year;

    fetchTeamDecisions(round_number, 'team-reports')
      .then(data => {
        let totalCosts = 0;
        let avgMaterialCostsPerUnit = 0;
        let avgLaborCostsPerUnit = 0;
        let avgOverheadCostsPerUnit = 0;
        let endingInventory = 0;

        if (data.operations_decisions && data.operations_decisions.products) {
          data.operations_decisions.products.forEach(product => {
            totalCosts += product.total_costs || 0;
            avgMaterialCostsPerUnit += product.material_costs || 0;
            avgLaborCostsPerUnit += product.labor_costs || 0;
            avgOverheadCostsPerUnit += product.overhead_costs || 0;
          });
        }

        if (data.inventory_balances) {
          data.inventory_balances.forEach(product => {
            endingInventory += product.ending_inventory || 0;
          });
        }

        this.setState({
          totalCosts,
          avgMaterialCostsPerUnit,
          avgLaborCostsPerUnit,
          avgOverheadCostsPerUnit,
          endingInventory,
          loading5: false,
          loading6: false
        });
      })
      .catch(err => { });
  };

  loadMetricsAndCompetition = () => {
    const round_number = this.current_year;
    const team = Teams.currentTeam();
    const teamId = team ? Number(team.id) : 0;
    const competitionId = team ? Number(team.competition) : 0;
    const roundObj = this.state.rounds.find(i => Number(i.number) === round_number);
    const roundId = roundObj ? Number(roundObj.id) : 0;

    fetchCompetitionMetrics(competitionId, roundId)
      .then(allTeamsData => {
        // Extract team metrics (debt/equity/wacc)
        let metrics = {
          debt: "0.00",
          equity: "100.00",
          wacc: "0.00"
        };

        const teamData = allTeamsData.find(i => Number(i.team) === teamId);

        if (teamData && teamData.debt_to_total_capital) {
          metrics.debt = (teamData.debt_to_total_capital * 100).toFixed(2);
          metrics.equity = (100 - Number(metrics.debt)).toFixed(2);
        }

        if (teamData && teamData.wacc) {
          metrics.wacc = (teamData.wacc * 100).toFixed(2);
        }

        // Extract competition metrics and build teams list from metricsreports
        let competition_metrics = {};
        let teams = { ...this.state.teams };
        const competitionTeams = [];
        allTeamsData.forEach(row => {
          competition_metrics[row.team] = {
            MarketShare: row["market_share"] ? row["market_share"] : 0,
            Revenues: row["net_revenues"] ? row["net_revenues"] : 0,
            GrossMargins: row["gross_margin"] ? row["gross_margin"] : 0
          };
          if (row.team_name) {
            teams[row.team] = row.team_name;
            if (!competitionTeams.find(t => t.id === row.team)) {
              competitionTeams.push({
                id: row.team,
                name: row.team_name,
                competition: row.competition
              });
            }
          }
        });

        // Update teams_data in localStorage so chart colors work
        if (competitionTeams.length > 0) {
          const existing = Teams.teams();
          const existingIds = new Set(existing.map(t => t.id));
          const merged = [...existing];
          competitionTeams.forEach(t => {
            if (!existingIds.has(t.id)) {
              merged.push(t);
            }
          });
          const { reactLocalStorage } = require('reactjs-localstorage');
          reactLocalStorage.setObject("teams_data", merged);
          persistTeamColorIndexMap(merged);
        }

        this.setState({
          metrics,
          competition_metrics,
          teams,
          loading7: false,
          loading11: false
        });
      })
      .catch(err => { });
  };


  get isLoading() {
    const {
      loading1,
      loading2,
      loading3,
      loading4,
      loading5,
      loading6,
      loading7,
      loading8,
      loading9,
      loading10,
      loading11
    } = this.state;

    return (
      loading1 ||
      loading2 ||
      loading3 ||
      loading4 ||
      loading5 ||
      loading6 ||
      loading7 ||
      loading8 ||
      loading9 ||
      loading10 ||
      loading11
    );
  }



  loadTeamGrade = () => {
    const round_number = this.current_year;

    getRequest(`${process.env.REACT_APP_API_URL}team/grading/?round_number=${round_number}`)
      .then(res => {
        const { rounds } = this.state;
        const round = rounds.find(i => i.number === round_number);
        if (!round) return;

        const obj = res.body.find(i => i.round === round.id);
        if (obj) {
          this.setState({
            team_grade: obj.weighted_value * 100,
            rank_name: obj.ranking || "Unknown Rank"
          });
        }
      })
      .catch(err => { });
  };

  render() {
    const {
      section,
      step,
      data,
      teams,
      netRevenues,
      netProfits,
      actual,
      expected,
      incomeStatement,
      balanceSheet,
      cashFlow,
      costOfSales,
      rndCosts,
      promotionCosts,
      sellingCosts,
      total_demand,
      holdingCosts,
      endingInventory,
      totalCosts,
      avgMaterialCostsPerUnit,
      avgLaborCostsPerUnit,
      avgOverheadCostsPerUnit,
      interestExpense,
      financeRaised,
      returnedToInvestors,
      metrics,
      competition_metrics,
      share_price,
      rank_name,
      team_grade
    } = this.state;
    const current_year = this.current_year;
    const isLoading = this.isLoading;

    return (
      <div className="team-reports-container">
        <TeamReportsTopNavigation
          section={section}
          step={step}
          changeStep={this.changeStep}
          current_year={current_year}
        />
        {section === 1 && isLoading === false && (
          <TeamReportsSection1 step={step} rank_name={rank_name} />
        )}
        {section === 2 && isLoading === false && (
          <TeamReportsSection2
            step={step}
            team_grade={team_grade}
            rank_name={rank_name}
            data={data}
            teams={teams}
            share_price={share_price}
            current_year={current_year}
            competition_metrics={competition_metrics}
          />
        )}
        {section === 3 && isLoading === false && (
          <TeamReportsSection3
            step={step}
            expectedNetProfits={this.expectedNetProfits}
            actualNetProfits={this.actualNetProfits}
            netRevenues={netRevenues}
            netProfits={netProfits}
            actual={actual}
            expected={expected}
            current_year={current_year}
            incomeStatement={incomeStatement}
          />
        )}
        {section === 4 && isLoading === false && (
          <TeamReportsSection4
            step={step}
            incomeStatement={incomeStatement}
            costOfSales={costOfSales}
            netRevenues={netRevenues}
            rndCosts={rndCosts}
            promotionCosts={promotionCosts}
            sellingCosts={sellingCosts}
            current_year={current_year}
            data={data}
            teams={teams}
            total_demand={total_demand}
            endingInventory={endingInventory}
          />
        )}
        {section === 5 && isLoading === false && (
          <TeamReportsSection5
            step={step}
            data={data}
            teams={teams}
            costOfSales={costOfSales}
            holdingCosts={holdingCosts}
            incomeStatement={incomeStatement}
            current_year={current_year}
            totalCosts={totalCosts}
            avgMaterialCostsPerUnit={avgMaterialCostsPerUnit}
            avgLaborCostsPerUnit={avgLaborCostsPerUnit}
            avgOverheadCostsPerUnit={avgOverheadCostsPerUnit}
          />
        )}
        {section === 6 && isLoading === false && (
          <TeamReportsSection6
            step={step}
            incomeStatement={incomeStatement}
            current_year={current_year}
            interestExpense={interestExpense}
            data={data}
            teams={teams}
            metrics={metrics}
            financeRaised={financeRaised}
            returnedToInvestors={returnedToInvestors}
          />
        )}
        {section === 7 && isLoading === false && (
          <TeamReportsSection7
            step={step}
            incomeStatement={incomeStatement}
            balanceSheet={balanceSheet}
            cashFlow={cashFlow}
            current_year={current_year}
          />
        )}
        {isLoading === true && (
          <div className="team-reports-loading">
            <Loader type="ball-scale-ripple" active />
          </div>
        )}
      </div>
    );
  }
}

export default TeamReports;



// WEBPACK FOOTER //
// ./src/containers/team-reports.js